module.exports = require("angular");


//////////////////
// WEBPACK FOOTER
// external "angular"
// module id = 7
// module chunks = 0